"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwaAgendaStrings = exports.OwaAgendaStringsStringModule = void 0;
/* tslint:disable */
var index_1 = require("./index");
var keys = ['agendaEventAllDayText', 'agendaPaneEmptyStatePrimaryText', 'agendaPaneEmptyStateSecondaryText', 'agendaEventInXTimeText', 'agendaEventNowText', 'agendaJoinButtonText', 'joinSkypeMeetingButton', 'joinTeamsMeetingButton'];
exports.OwaAgendaStringsStringModule = index_1.registerStringPackage('owa-agenda-strings', null, keys);
var exportedObject = {};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return exports.OwaAgendaStringsStringModule.strings.get(key); } });
});
/**
 * Selector to return the strings collection, so it can more easily be mocked.
 */
var getOwaAgendaStrings = function () { return exportedObject; };
exports.getOwaAgendaStrings = getOwaAgendaStrings;
exports.default = exportedObject;
